/* eslint-disable max-lines-per-function */
import { remoteImageStaticUrl } from "common/utils/remote-image";
import { cn } from "tailwind-variants";
import "./CustomComparison.scss";
import { renderList } from "common/vue/render-list";

export default function CustomComparison({ ...restProps }) {
  const list = [
    {
      title: "Original",
      imageName: "original"
    },
    {
      title: "Sharpened",
      imageName: "sharpened"
    },
    {
      title: "Background Removed",
      imageName: "background_removed"
    },
    {
      title: "Color Changes",
      imageName: "color_changes"
    },
    {
      title: "Elements Removed",
      imageName: "elements_removed"
    },
    {
      title: "Text Changes",
      imageName: "text_changes"
    }
  ];

  function computedImageUrl(imageName) {
    return remoteImageStaticUrl(`gen/expert_edit_illustration_1/${imageName}.png`);
  }

  return (
    <div {...restProps} className={cn("custom-comparison scope-441a917e", restProps.className)}>
      <h2 className="custom-comparison__header scope-441a917e">Illustrative Example</h2>
      <div className="custom-comparison__body scope-441a917e">
        {renderList(list, item => (
          <div className="custom-comparison__item scope-441a917e" key={item.title}>
            <h3 className="custom-comparison__item-title scope-441a917e">{item.title}</h3>
            <div
              className={cn(
                "custom-comparison__item-image-wrapper scope-441a917e",
                `custom-comparison__item-image-wrapper--${item.imageName}`
              )}
            >
              <img
                className="custom-comparison__item-image scope-441a917e"
                alt={`Illustration for ${item.title}`}
                src={computedImageUrl(item.imageName)}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
